

























































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { PaginationModel, VHeaders } from "@/models/pagedlistmodel";
import { Base } from "@/components/common/base";
import { IDialogOption } from "@/models/dialog";
import { FileHelper as _file } from "@/helper/file.helper";
import { DateTimeHelper as _dateTime } from "@/helper/date-time.helper";
import { VAction } from "@/models/pagedlistmodel";
import { paymentService } from "@/shared";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    postingDate: {
      get() {
        return this.currentDate;
      },
      set(value) {
        return value;
      },
    },
    formattedStartDate: {
      get() {
        if (this.reconcilPostingDate) {
          const d = this.formatDate(this.reconcilPostingDate);
          let lastDate = _dateTime.currentDate(
            _dateTime.addDays(new Date(this.reconcilPostingDate), 45)
          );
          if (lastDate > this.todayDate) {
            lastDate = this.todayDate;
          }
          this.maxToDate = lastDate;
          return d;
        } else {
          return _dateTime.currentDate(new Date());
        }
      },
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
    Calendar: () => import("@/components/common/app.calendar.vue"),
    Datepicker: () => import("@/components/common/app.datepicker.vue"),
    SnackBarLoader: () => import("@/components/common/loader.vue"),
  },
})
export default class ReconcileListPage extends Base {
  public reconcilList: any[] = [];
  public reconcilHeader: VHeaders[] = [];
  public selectedAttachments = [];
  public totalNetAmount: any = 0;
  public sumOfFee: any = 0;
  public currentDate: string = this.postingDate(new Date());
  public statementId: string = "";
  public type: string = "";

  public statusList: any[] = [
    {
      id: "All",
      text: "All",
    },
    {
      id: "Mismatch",
      text: "Mismatch",
    },
    {
      id: "Pending",
      text: "Pending",
    },
  ];

  public maxToDate: any = _dateTime.currentDate(
    _dateTime.addDays(new Date(), 45)
  );
  public todayDate: any = _dateTime.currentDate(new Date());

  public flags: any = {
    showStartDatePicker: false,
    showEndDatePicker: false,
  };
  public reconcilPostingDate = "";

  public params: any = {
    status: "Mismatch",
  };

  public startDateFlag: string = "";
  public formattedStartDate: string;

  public loading: boolean = false;
  public resetFilter: boolean = false;
  public documentNumber: string = "";
  public transactionId: string = "";
  public isRefreshPosted: boolean = false;

  public selected: any[] = [];
  public actions: any[] = [];
  public pagination = new PaginationModel("initiatedAt", true);
  constructor() {
    super();
  }

  // Dialog
  public syncDialog: IDialogOption = {
    width: 400,
    title: "Refresh DMS Data",
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: "Yes",
      disable: false,
    },
    onAction: (): void => {
      this.refreshReconsileDetail();
    },
    onClose: (): void => {
      // this.onCloseVehicleInvoicePopup();
    },
  };

  public documentDialog: IDialogOption = {
    width: 600,
    title: "Update Document Number",
    model: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t("arPaymentReport.refundDialog.btnSubmit") as string,
      disable: false,
    },
    onAction: (): void => {
      this.updateDocumentNumber();
    },
    onClose: (): void => {
      this.clearDocumentNumber();
    },
  };

  public clearDocumentNumber() {
    this.documentNumber = "";
    this.transactionId = "";
  }

  public validateStartDate(date) {
    this.startDateFlag = date;
    const re = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    const validate = re.test(String(date));
    if (validate) {
      const formatedDate = _dateTime.currentDate(new Date(date));
      this.reconcilPostingDate = formatedDate;
    }
    return re.test(String(date));
  }

  public formatDate(date) {
    if (!date) {
      return null;
    }
    const [year, month, day] = date.split("-");
    return `${month}/${day}/${year}`;
  }

  public async updateDocumentNumber() {
    try {
      if (this.documentNumber == "") {
        this.showAlert(false, "Please enter document number.");
        return;
      }
      this.documentDialog.action.disable = true;

      var response = await paymentService.updateReconcileDetail(
        this.documentNumber,
        this.transactionId
      );

      this.showAlert(true, response.responseMessage);
      this.documentDialog.action.disable = true;
      this.getReconcilationPayments();
    } finally {
      this.documentDialog.action.disable = false;
      this.documentDialog.model = false;
      this.documentNumber = "";
      this.transactionId = "";
    }
  }

  public resetFilters() {
    this.params.endDate = "";
    this.params.startDate = "";
    this.resetFilter = !this.resetFilter;
  }

  public setInvoiceDateParmsGlAccount(dates: any) {
    if (dates.length > 0) {
      if (dates[0]) {
        this.params.startDate = dates[0];
      }
      if (dates[1]) {
        this.params.endDate = dates[1];
      }
    }
  }

  public postingDate(date?): string {
    if (!date && typeof date !== "function") {
      date = new Date();
    }
    let month = (date.getMonth() + 1).toString();
    if (Number(month) < 10) {
      month = "0" + month;
    }
    const d = `${date.getFullYear()}-${month}-${date.getDate()}`;
    return d;
  }

  public setActions() {
    this.actions = [
      {
        type: "button",
        icon: "fas fa-edit",
        title: "Update Detail",
        action: (model: any) => {
          this.transactionId = model.id;
          this.documentDialog.model = true;
        },
      },
    ];
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }

  public callMethod(methodName): void {
    if (methodName === "backToReconcilList") {
      this.backToReconcilList();
    } else if (methodName === "refreshReconsileButton") {
      this.validateAndShowDialog();
    }
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }

  public validateAndShowDialog() {
    if (this.isRefreshPosted) {
      return;
    } else this.syncDialog.model = true;
  }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: "1",
      type: "button",
      title: "Back",
      disabled: false,
      visible: true,
      class: "btn",
      label: "Back To List",
      click: "backToReconcilList",
      icon: "fas fa-arrow-left",
      requestProgress: true,
    });

    buttons.push({
      id: "2",
      type: "button",
      title: "Refresh DMS Data",
      disabled: false,
      visible: true,
      class: "btn",
      label: "Refresh DMS Data",
      click: "refreshReconsileButton",
      icon: "fas fa-sync",
      requestProgress: true,
    });
    this.$emit("updateToolBar", buttons);
  }

  public backToReconcilList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: "app.paymentreports.reconciliation" });
    }
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "reconciliationList");
    if (!this.isFeatureToAccess('HasSquarePaymentProvider')) {
      this.$router.push({ name: 'app.dashboard' });
    }
    this.setActions();
    this.setHeaders();
    if (this.$route.params.id) {
      this.statementId = this.$route.params.id;
      this.type = this.$route.params.type;
      this.getReconcilationPayments();
    }
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setFromDateValue(date: any): void {
    this.currentDate = date;
  }

  public setHeaders() {
    this.reconcilHeader = [
      {
        text: "Date",
        align: "left",
        value: "initiatedAt",
        sortable: true,
        fieldType: "date",
      },
      {
        text: "Document",
        align: "left",
        value: "postingDetails.documentNumber",
        sortable: true,
        fieldType: "template",
        template: (item) => {
          return `<span>${item.postingDetails.updatedDocumentNumber == undefined ||
            item.postingDetails.updatedDocumentNumber == "undefined"
            ? item.postingDetails.documentNumber
            : item.postingDetails.updatedDocumentNumber
            }</span>`;
        },
      },
      {
        text: "Record Identifier",
        align: "left",
        value: "postingDetails.recordIdentifier",
        sortable: true,
        fieldType: "template",
        template: (item) => {
          return `<span>${item.postingDetails.recordIdentifier == undefined ||
            item.postingDetails.recordIdentifier == "undefined"
            ? "N/A"
            : item.postingDetails.recordIdentifier
            }</span>`;
        },
      },
      {
        text: "Status",
        align: "left",
        value: "postingDetails.dmsStatus",
        sortable: false,
        fieldType: "template",
        template: (item) => {
          return `<span>${item.postingDetails.dmsStatus == true
            ? item.postingDetails.reconcileStatus == "Y"
              ? "Entry Found (Reconciled)"
              : "Entry Found (Not Reconciled)"
            : "Pending (Missing Dms Entry)"
            }</span>`;
        },
      },
      {
        text: "EventType",
        align: "left",
        value: "postingDetails.type",
        sortable: false,
        fieldType: "template",
        template: (item) => {
          return `<span>${item.settlementDetails.type == "CHARGE" ? "PAYMENT" : item.settlementDetails.type
            }</span>`;
        },
      },
      {
        text: "Last4",
        align: "left",
        value: "settlementDetails.cardLastFour",
        sortable: false,
        fieldType: "template",
        template: (item) => {
          return `<span>${item.settlementDetails.cardLastFour ? item.settlementDetails.cardLastFour : 'N/A'
            }</span>`;
        },
      },
      {
        text: "Dms Amount",
        align: "left",
        value: "settlementDetails.transactionActualAmount",
        sortable: false,
        fieldType: "template",
        template: (item) => {
          if (item.settlementDetails.transactionActualAmount && item.postingDetails.recordIdentifier) {
            return `<span>${item.settlementDetails.type == "CHARGE"
              ? item.settlementDetails.transactionActualAmount
              : item.settlementDetails.transactionActualAmount * -1
              }</span>`;
          } else if (item.settlementDetails.netTotal && item.postingDetails.recordIdentifier) {
            var fees =
              item.settlementDetails.fees > 0
                ? item.settlementDetails.fees
                : item.settlementDetails.fees * -1;

            var dmsAmount =
              (item.settlementDetails.netTotal + fees) / 100 -
              item.settlementDetails.serviceCharges;
            return `<span>${item.settlementDetails.type == "CHARGE"
              ? dmsAmount.toFixed(2)
              : (dmsAmount * -1).toFixed(2)
              }</span>`;
          } else {
            return "<span>N/A</span>";
          }

        },
      },
      {
        text: "Net Total",
        align: "left",
        value: "settlementDetails.netTotal",
        sortable: false,
        fieldType: "template",
        template: (item) => {
          return `<span>${item.settlementDetails.netTotal / 100}</span>`;
        },
      },
      {
        text: "Convenience Fee",
        align: "left",
        value: "settlementDetails.serviceCharges",
        sortable: false,
        // fieldType: 'template',
        // template: (item) => {
        //   return `<span>${item.settlementDetails.convenienceFee / 100}</span>`;
        // },
      },
      {
        text: "Fees",
        align: "left",
        value: "settlementDetails.fees",
        sortable: false,
        fieldType: "template",
        template: (item) => {
          return `<span>${item.settlementDetails.netTotal > 0 ? "" : "-"}${item.settlementDetails.fees > 0
            ? item.settlementDetails.fees / 100
            : (item.settlementDetails.fees / 100) * -1
            }</span>`;
        },
      },
      {
        text: "Total",
        align: "left",
        value: "settlementDetails.fees",
        sortable: false,
        fieldType: "template",
        template: (item) => {
          return `<span>${item.settlementDetails.netTotal > 0 ? "" : "-"}${((item.settlementDetails.netTotal > 0
            ? item.settlementDetails.netTotal
            : item.settlementDetails.netTotal * -1) +
            (item.settlementDetails.fees > 0
              ? item.settlementDetails.fees
              : -1 * item.settlementDetails.fees)) /
            100
            }</span>`;
        },
      },
      {
        align: "left",
        text: "Action",
        isNotDataProp: true,
        sortable: false,
      },
    ];
  }

  public searchPayments(): void {
    if (this.params.paymentstatus == "") {
      this.showAlert(false, "Please select status");
      return;
    }
    if (this.params.startDate == "") {
      this.showAlert(false, "Please select start Date");
      return;
    }
    if (this.params.endDate == "") {
      this.showAlert(false, "Please select end Date");
      return;
    }
    this.getReconcilationPayments();
  }

  public isShownCheckBox(item) {
    return item && !item.postingDetails.dmsStatus;
  }

  public addAttachment(attachment: any): boolean {
    if (attachment.selected) {
      this.selectedAttachments.push(attachment.settlementDetails.paymentId);
      this.totalNetAmount +=
        attachment.settlementDetails.netTotal &&
          attachment.settlementDetails.netTotal > 0
          ? attachment.settlementDetails.netTotal / 100
          : 0;

      this.sumOfFee +=
        attachment.settlementDetails && attachment.settlementDetails.fees > 0
          ? attachment.settlementDetails.fees
          : 0;
    } else {
      const index = this.selectedAttachments.indexOf(
        attachment.settlementDetails.paymentId
      );
      if (index > -1) {
        this.selectedAttachments.splice(index, 1);
        var totalAmountToSub =
          attachment.settlementDetails.netTotal &&
            attachment.settlementDetails.netTotal > 0
            ? attachment.settlementDetails.netTotal / 100
            : 0;

        this.totalNetAmount = this.totalNetAmount - totalAmountToSub;

        var totalFeeToSub =
          attachment.settlementDetails && attachment.settlementDetails.fees > 0
            ? attachment.settlementDetails.fees
            : 0;

        this.sumOfFee = this.sumOfFee - totalFeeToSub;
      }
    }
    return true;
  }

  public async getReconcilationPayments(): Promise<void> {
    try {
      this.loading = true;
      const result = await paymentService.getReconciliationAsync(
        this.statementId,
        this.params.status,
        this.type,
        this.pagination
      );
      this.reconcilList = result.results;
      this.pagination.totalItems = result.total;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any): void {
    this.pagination = paging;
    this.getReconcilationPayments();
  }

  public async refreshReconsileDetail(): Promise<void> {
    try {
      this.syncDialog.model = false;
      this.isRefreshPosted = true;

      var response = await paymentService.refreshReconcileDetails(
        this.statementId,
        "Square"
      );
      if (response.status) {
        this.showAlert(
          true,
          "Sync is in progress please wait and refresh page after few minutes. We will notify you as job completes"
        );
        // this.showAlert(true, response.responseMessage);
        // this.getReconcilationPayments();
      } else {
        this.showAlert(false, response.responseMessage);
      }
    } finally {
      this.isRefreshPosted = false;
    }
  }
}
